import React, { Component, Fragment } from 'react';
import {
    DatePickerComponent, PageListComponent, HeaderListComponent,
} from "../../../common/component/Index";
import DEFINE, { PATHS, DATE_TIME_FORMAT } from "../../../../../constants/Define";
import { isEqual, get } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import SaleReport from '../../../../../models/SaleReport';

import Wrapper from './../../../common/component/Wrapper';
import Button, { ButtonGroup } from './../../../common/component/Button';

import { omit } from 'lodash';
import ReportList from './ReportList';
import './ReportCashFlow.less';

import moment from 'moment';
import ANT from 'antd';
import Ripple from '../../../common/component/Ripple';
import { Link } from 'react-router-dom';

let permisionActions = [];
const defaultState = {

};

const CURRENT_DATE_RANGE_ENUM = {
    DATE: [moment.utc().startOf('days'), moment.utc().endOf('days')],
    WEEK: [moment.utc().startOf('isoWeeks'), moment.utc().endOf('days')],
    MONTH: [moment.utc().startOf('months'), moment.utc().endOf('days')],
}
export default class ReportCashFlow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            filters: {
                orderCode: !!this.props.match.params.orderCode ? this.props.match.params.orderCode : undefined
            },
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.CASH_FLOW_REPORT);
        this.getDataCashFlowReport(this.state.filters);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params && !isEqual(nextProps.match.params.orderCode, this.props.match.params.orderCode)) {
            this.getDataCashFlowReport({
                orderCode: nextProps.match.params.orderCode
            })

            this.setState({
                filters: {
                    orderCode: nextProps.match.params.orderCode
                }
            })
        }
    }

    render() {
        const { t, reportState } = this.props;
        const { isFetching, cashFlowReport } = reportState;
        return (
            <PageListComponent className="page-redeemtion-report">
                <HeaderListComponent
                    path={this.props.match.path}
                    groupPath={'reports'}
                    titleHeader={t('item.report.cashflow')}
                    // componentRight={this.renderFilterSection()}
                    componentRight={
                        <Fragment>
                            { permisionActions && permisionActions.allowReceiptsPayslipCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.REPORT.CASH_FLOW_REPORT.CREATE.path}
                                        className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                        </Fragment>
                    }
                />
                <div className="filter-range-date">
                    <div className="col-md-4">
                        {this.renderFilterSection()}
                    </div>
                </div>
                <Wrapper className="">
                    <ReportList 
                        ref={this.cashFlowRef}
                        data={cashFlowReport}
                        loading={isFetching}
                        onTableChange={this.onTableChange}
                        defaultValue={{
                            orderCode: this.state.filters.orderCode
                        }}
                    />
                </Wrapper>
            </PageListComponent>
        );
    }

    getDataCashFlowReport = (filters) => {
        if (!filters) filters = this.getCurrentFilters();
        filters = omit(filters, ['totalCount', 'totalPage'])
        this.setState({ filters });
        this.props.getCashFlowReport(filters);
    }

    getCurrentFilters = (removeFields) => {
        const { reportState: { cashFlowReport } } = this.props;
        const filters = omit(cashFlowReport, ['cashFlows']);
        return removeFields ? omit(filters, removeFields) : filters;
    }

    onTableChange = (pagination, filters, sorter) => {
        let currentFilters = this.getCurrentFilters();
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex']);
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getCashFlowReport(newFilters);
    };

    onSelectDateRange = (data) => {
        const filters = this.getCurrentFilters(['totalCount', 'totalPage'])
        filters.startDate = data.fullValue[0];
        filters.endDate = data.fullValue[1];
        this.collapseAllRow()
        return this.props.getCashFlowReport(filters);
    }

    collapseAllRow = () => {
        if(this.cashFlowRef && this.cashFlowRef.current){
            this.cashFlowRef.current.collapseAllRow();
        }
    }

    renderFilterSection() {
        const { t, reportState } = this.props;
        const { cashFlowReport } = reportState;
        return (
            <Wrapper className="row col-md-12 m-0 p-0 w100-percent">
                <Wrapper className={`col-md-7 m-0 p-0 pr-2 button-section`}>
                    <ButtonGroup>
                        <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.DATE })}>{t(`item.report.currentDate`)}</Button>
                        <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.WEEK })}>{t(`item.report.currentWeek`)}</Button>
                        <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.MONTH })}>{t(`item.report.currentMonth`)}</Button>
                    </ButtonGroup>
                </Wrapper>
                <Wrapper className={`col-md-5 m-0 p-0`}>
                    <DatePickerComponent className={`form-control applyDates w100-percent`}
                        hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                        style={{ padding: 0, border: 0 }}
                        onChange={this.onSelectDateRange} name={`applyDates`}
                        placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                        value={[cashFlowReport.startDate, cashFlowReport.endDate]}
                    />
                </Wrapper>
            </Wrapper>
        )
    }

}